module.exports = __webpack_public_path__ + "static/messaging_app_cover-6a3d02f007e6a774c7385d140919a41e.png";